import React from 'react';
export function StickyAlertBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-spice-800 text-white py-1.5 md:py-3 overflow-hidden shadow-md" data-id="element-204">
      <div className="whitespace-nowrap animate-marquee font-bold text-sm md:text-base tracking-wider" data-id="element-205">
        <span className="mx-4" data-id="element-206">
          🔥 SOLO POR HOY 8 BONOS GRATIS + ACCESO INMEDIATO 🔥
        </span>
        <span className="mx-4" data-id="element-207">
          🔥 SOLO POR HOY 8 BONOS GRATIS + ACCESO INMEDIATO 🔥
        </span>
        <span className="mx-4" data-id="element-208">
          🔥 SOLO POR HOY 8 BONOS GRATIS + ACCESO INMEDIATO 🔥
        </span>
        <span className="mx-4" data-id="element-209">
          🔥 SOLO POR HOY 8 BONOS GRATIS + ACCESO INMEDIATO 🔥
        </span>
      </div>
    </div>;
}